import Nav from "../components/Nav";
import Footer from "../components/Footer";
import NewsletterBlock from "../components/NewsletterBlock";
import useReveal from "../hooks/useReveal";

export default function Newsletter() {
  useReveal();

  return (
    <>
      <Nav />
      <header className="page-header" data-testid="newsletter-page">
        <div className="container">
          <h1 className="reveal">
            Una carta al mes, <em>sin ruido</em>.
          </h1>
          <p className="reveal d1">
            Un solo correo mensual. Sin promociones, sin rastreo. Puedes darte
            de baja con dos clics.
          </p>
        </div>
      </header>

      <NewsletterBlock extended />
      <Footer />
    </>
  );
}
